import { type IDropdownItem } from 'shared/ui'
import { type GroupInbox } from 'entities/Inbox/model/GroupInbox'
import { type ConversationMenuStore } from 'pages/conversations/ui/ConversationMenu'

const typeUngroup = 'ungroup'

type IActionUngroup = {
  inbox: GroupInbox
  item: IDropdownItem
}

export const menuUngroup = (): IDropdownItem => {
  return {
    id: typeUngroup,
    iconL: 'remove',
    label: 'Ungroup',
  }
}

export const actionUngroup = ({ inbox, item }: IActionUngroup, store: ConversationMenuStore) => {
  if (item.id === typeUngroup) {
    store.groupsApiMenuStore.onDeleteTeamsGroupsById(inbox)
  }
}
